import { ICheckoutCartOffer, ICheckoutCartOfferPrice } from '@/interfaces/Checkout';
import { IPurchase, IPurchaseCart, IExtraParam, IPurchasePaymentStructure } from '@/interfaces/Purchase';

import { EPaymentMethod, EPaymentMethodTypes, ECardStep } from '@/helpers/enums';

import { PurchaseCard } from './PurchaseCard';
import { Cryptography } from './Cryptography';

export class Purchase implements IPurchase {
  status: IPurchaseCart;
  cart: IPurchaseCart;
  offer_id: number;
  offer_price_id: number;
  selectedOffer: ICheckoutCartOffer;
  rootOffer: ICheckoutCartOffer;
  payment_profile: any;
  installments: number | null = 1;
  payment_type: string | null = null;
  fraud_id: string | null = null;
  address_id?: number;
  extra_params: IExtraParam[];
  sales_channel?: string;

  // new
  payment_structure: IPurchasePaymentStructure;

  constructor(selectedOfferPrice: ICheckoutCartOfferPrice, selectedOffer: ICheckoutCartOffer, rootOffer: ICheckoutCartOffer, cartId: string, sales_channel?: string, address_id?: number) {
    const payment_method_code = selectedOffer.payment.selectedPaymentMethod;

    let installments: number | null = 1;
    let paymentType: string | null = null;
    let koinFroudId: string | null = null;
    let paymentProfile: any = {
      payment_method_code,
    };

    let paymentSecondProfile: any = {
      payment_method_code,
    };

    let payment_profile: any = {};
    let second_payment_profile: any = {};
    let purchaseSecondCard: any = null;

    const paymentMethodType = selectedOffer.payment.getTypeOfPaymentMethod(payment_method_code)!.type;

    const main_payment_condition = {
      installments,
      payment_method_code,
    };

    if (EPaymentMethodTypes.creditCard === paymentMethodType) {
      const creditCardPaymentMethod = selectedOffer.payment.getPaymentMethod(EPaymentMethod.creditCard);

      const purchaseCard = creditCardPaymentMethod.step === ECardStep.new
        ? PurchaseCard.fromNewCard(creditCardPaymentMethod.card)
        : new PurchaseCard(creditCardPaymentMethod.card);

      if (creditCardPaymentMethod && creditCardPaymentMethod.secondCard) {
        purchaseSecondCard = creditCardPaymentMethod.secondStep === ECardStep.new
          ? PurchaseCard.fromNewCard(creditCardPaymentMethod.secondCard)
          : new PurchaseCard(creditCardPaymentMethod.secondCard);
      }

      main_payment_condition.installments = creditCardPaymentMethod.installment!.number;

      paymentProfile = {
        ...paymentProfile,
        id: creditCardPaymentMethod.card && creditCardPaymentMethod.card.id,
        card_flag: purchaseCard && purchaseCard.card_flag,
        card_first_digits: purchaseCard && purchaseCard.card_first_digits,
      };

      payment_profile = {
        ...paymentProfile,
        ...creditCardPaymentMethod.step === ECardStep.new && {
          card_info: new Cryptography().encrypt(purchaseCard),
        },
      };

      if (creditCardPaymentMethod && creditCardPaymentMethod.second_payment_condition) {
        paymentSecondProfile = {
          ...paymentSecondProfile,
          id: creditCardPaymentMethod.secondCard && creditCardPaymentMethod.secondCard.id,
          card_flag: purchaseSecondCard && purchaseSecondCard.card_flag,
          card_first_digits: purchaseSecondCard && purchaseSecondCard.card_first_digits,
        };

        second_payment_profile = {
          ...paymentSecondProfile,
          ...creditCardPaymentMethod.secondStep === ECardStep.new && {
            card_info: new Cryptography().encrypt(purchaseSecondCard),
          },
        };
      }

      this.payment_structure = {
        offer_payment_condition_id: creditCardPaymentMethod.offer_payment_condition_id,
        main_payment_condition: {
          ...main_payment_condition,
          id: creditCardPaymentMethod.main_payment_condition && creditCardPaymentMethod.main_payment_condition.id,
          amount: creditCardPaymentMethod.main_payment_condition && creditCardPaymentMethod.main_payment_condition.amount,
          installments: (creditCardPaymentMethod.main_payment_condition && creditCardPaymentMethod.main_payment_condition.installments) || creditCardPaymentMethod.installment!.number,
          payment_profile,
        },
        ...creditCardPaymentMethod && creditCardPaymentMethod.second_payment_condition && creditCardPaymentMethod.second_payment_condition!.installments && {
          second_payment_condition: {
            id: creditCardPaymentMethod.second_payment_condition.id,
            amount: creditCardPaymentMethod.second_payment_condition.amount,
            installments: creditCardPaymentMethod.second_payment_condition.installments,
            payment_method_code: creditCardPaymentMethod.second_payment_condition.payment_method_code,
            ...creditCardPaymentMethod && creditCardPaymentMethod.secondCard && {
              payment_profile: second_payment_profile,
            }
          },
        }
      };

      this.installments = null;
    }

    if (EPaymentMethodTypes.wireTransfer === paymentMethodType) {
      const wireTransferPaymentMethod = selectedOffer.payment.getPaymentMethod(EPaymentMethod.wireTransfer);

      payment_profile = {
        ...payment_profile,
        ...paymentProfile,
        id: null,
        bank_code: wireTransferPaymentMethod.account.bank_code,
        bank_branch: wireTransferPaymentMethod.account.bank_branch,
        bank_account: wireTransferPaymentMethod.account.bank_account,
        bank_check_digit: wireTransferPaymentMethod.account.bank_check_digit,
        bank_third_party_registry: wireTransferPaymentMethod.account.bank_third_party_registry,
      };

      this.payment_structure = {
        offer_payment_condition_id: wireTransferPaymentMethod.offer_payment_condition_id,
        main_payment_condition: {
          ...main_payment_condition,
          installments,
          payment_profile,
        },
        second_payment_condition: null,
      };
    }

    if (EPaymentMethodTypes.bankSlip === paymentMethodType) {
      const bankSlipPaymentMethod = selectedOffer.payment.getPaymentMethod(EPaymentMethod.bankSlip);

      installments = bankSlipPaymentMethod!.installment && bankSlipPaymentMethod!.installment!.number > 1 ? bankSlipPaymentMethod!.installment!.number : 1;
      paymentType = bankSlipPaymentMethod!.installment && bankSlipPaymentMethod!.installment!.number > 1 ? bankSlipPaymentMethod!.installment!.payment_type : null;
      koinFroudId = bankSlipPaymentMethod!.installment && bankSlipPaymentMethod!.installment!.number > 1 ? bankSlipPaymentMethod!.fraudId : null;

      this.payment_structure = {
        offer_payment_condition_id: bankSlipPaymentMethod.offer_payment_condition_id,
        main_payment_condition: {
          ...main_payment_condition,
          installments,
        },
        second_payment_condition: null,
      };

      this.installments = null;
    }

    if (EPaymentMethodTypes.pix === paymentMethodType) {
      const pixPaymentMethod = selectedOffer.payment.getPaymentMethod(EPaymentMethod.pix);

      this.payment_structure = {
        offer_payment_condition_id: pixPaymentMethod.offer_payment_condition_id,
        main_payment_condition: {
          ...main_payment_condition,
          installments,
        },
        second_payment_condition: null,
      };
    }

    this.cart = { uuid: cartId };
    this.offer_id = selectedOffer.id as number;
    this.offer_price_id = selectedOfferPrice.id;
    this.address_id = address_id;
    this.payment_type = paymentType;
    this.fraud_id = koinFroudId;
    this.sales_channel = sales_channel;

    this.extra_params = [
      {
        type: 'text',
        key: 'user_agent',
        value: window.navigator.userAgent
      },
      {
        type: 'text',
        key: 'origin_url',
        value: document.referrer
      },
      {
        type: 'text',
        key: 'main_offer_id',
        value: rootOffer.id,
      }
    ];

    rootOffer.id !== selectedOffer.id && this.extra_params.push({
      type: 'text',
      key: 'related_offer_id',
      value: selectedOffer.related_id,
    });
  }
}
